export default "__VITE_ASSET__Bxrk7$hz__"